import { createFileRoute } from '@tanstack/react-router';
import { ShowcaseDashboard } from '@/features/showcases/showcase-dashboard';

export const Route = createFileRoute('/_authenticated/showcases/$showcaseId/')({
    head: () => ({ meta: [{ title: 'Showcase | promote.fun' }] }),
    component: ShowcaseDashboard,
});
